import { render, staticRenderFns } from "./IncomeHeader.vue?vue&type=template&id=492ed587&"
import script from "./IncomeHeader.vue?vue&type=script&lang=js&"
export * from "./IncomeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports